export const environment = {
    production: true,
    baseHref: '/SanCarlosProjects',
    apiBase: 'https://mydashgis.com/SanCarlosProjects',
    debug: true,
};
